import { boot } from 'quasar/wrappers'
import { useUserInfoStore } from 'src/stores/user-info-store';
import { useAuthStore } from 'src/stores/auth-store';

export default boot(({ app }) => {
  const authStore = useAuthStore();
  const userInfoStore = useUserInfoStore();
  app.provide('authStore', authStore);
  app.provide('userInfoStore', userInfoStore);
  //console.log(authStore.isAuthenticated, userInfoStore.id) 
})